export function contactJS () {
    document.addEventListener('DOMContentLoaded', function () {

        let form;

        (function () {

            document.addEventListener('DOMContentLoaded', function () {
                form = ContactForm();
            });

            ///##|###############################################################################################
            ///  |  SINGLE INPUT
            ///==V===============================================================================================

            /**
             * Return a 'New' Object
             *
             * @returns {init}
             * @constructor
             */
            var ContactInput = function (data) {
                return new ContactInput.init(data);
            };

            /**
             ******************************************************************************************
             *
             *      Crypt.prototype
             *
             ******************************************************************************************
             *
             */
            ContactInput.prototype = {

                isValid: function () {
                    return this.isValidState;
                },
                isDirty: function () {
                    return this.isDirtyState;
                },

                verify: function () {
                    this.isValidState = this.getIsValid();
                    this.pushToDom();
                },

                getIsValid: function () {

                    if (this.node.getAttribute('type') === 'checkbox') {
                        return !this.isRequired || (this.isRequired && this.node.checked);
                    }

                    if (this.required && this.node.value.length <= 0) {
                        return false;
                    }
                    if ((this.min > 0) && this.node.value.length <= this.min) {
                        return false;
                    }
                    // REGEX CHECK

                    return true;
                },

                pushToDom: function () {
                    this.node.parentNode.dataset.valid = this.isValid();
                    this.node.parentNode.dataset.dirty = this.isDirty();
                }

            };


            /**
             * Initialize The Crypt APP
             *
             * set: data-rel, data-target, data-href
             */
            ContactInput.init = function (data) {

                this.node = data.node;
                this.regex = data.regex;
                this.min = data.min;

                console.log(data.node)

                this.isRequired = !!data.node.required;
                this.isDirtyState = false;
                this.isValidState = !this.isRequired;

                if (this.node.getAttribute('type') === 'checkbox') {
                    this.node.addEventListener('change', function () {

                        this.isDirtyState = true;

                        setTimeout(function () {
                            this.node.dataset.empty = this.node.value === '';
                            this.verify();
                            this.pushToDom();
                            document.dispatchEvent(new CustomEvent('form-change'));
                        }.bind(this), 5);

                    }.bind(this));
                } else {
                    this.node.addEventListener('keydown', function () {

                        this.isDirtyState = true;

                        setTimeout(function () {
                            this.node.dataset.empty = this.node.value === '';
                            this.verify();
                            this.pushToDom();
                            document.dispatchEvent(new CustomEvent('form-change'));
                        }.bind(this), 5);

                    }.bind(this));
                }

                this.pushToDom();
            };


            /**
             * Add Prototype Methods to global Crypt object
             *
             * @type {init}
             */
            ContactInput.init.prototype = ContactInput.prototype;


            ///##|###############################################################################################
            ///  |  CONTACT FORM
            ///==V===============================================================================================


            /**
             * Return a 'New' Object
             *
             * @returns {init}
             * @constructor
             */
            var ContactForm = function () {
                return new ContactForm.init();
            };

            /**
             ******************************************************************************************
             *
             *      Crypt.prototype
             *
             ******************************************************************************************
             *
             */
            ContactForm.prototype = {


                pushToDom() {

                    this.el.form.dataset.valid = this.state.isValid;
                    this.el.form.dataset.dirty = this.state.isDirty;
                    this.el.submit.disabled = !this.state.isValid;

                },

                collectInputs() {

                    this.el.inputs.name = ContactInput({node: this.el.form.querySelector('#name'), regex: '', min: 3});
                    this.el.inputs.mail = ContactInput({node: this.el.form.querySelector('#mail'), regex: '', min: 0});
                    this.el.inputs.phone = ContactInput({node: this.el.form.querySelector('#phone'), regex: '', min: 0});
                    this.el.inputs.text = ContactInput({node: this.el.form.querySelector('#text'), regex: '', min: 3});
                    this.el.inputs.privacy = ContactInput({
                        node: this.el.form.querySelector('#privacy-accept'),
                        regex: '',
                    });

                    this.el.submit = this.el.form.querySelector('#submit');

                },

                setCaptchaChecked() {
                    this.state.captchaChecked = true;
                },


                verifyForm() {

                    this.invalid = [];
                    this.state.isValid = this.state.captchaChecked;

                    for (var i in this.el.inputs) {
                        this.el.inputs[i].verify();
                        if (!this.el.inputs[i].isValid()) {
                            this.state.isValid = false;
                            this.invalid.push(this.el.inputs[i]);
                        }
                    }

                    this.pushToDom();
                }
            };


            /**
             * Initialize The Crypt APP
             *
             * set: data-rel, data-target, data-href
             */
            ContactForm.init = function () {

                this.el = {};
                this.el.form = document.getElementById('form');
                this.el.inputs = {};
                this.state = {};

                this.state.isValid = false;
                this.state.isDirty = false;
                this.state.captchaChecked = false;

                this.invalid = [];

                this.collectInputs();

                document.addEventListener('form-change', function (e) {
                    this.isDirty = true;
                    this.verifyForm();
                }.bind(this));

                this.el.submit.addEventListener('click', function (e) {

                    this.verifyForm();

                    if (!this.state.isValid) {
                        e.preventDefault();
                        this.el.form.dataset.tried = 'true';
                    }

                }.bind(this));
            };


            /**
             * Add Prototype Methods to global Crypt object
             *
             * @type {init}
             */
            ContactForm.init.prototype = ContactForm.prototype;


        }());


        function captchaClicked() {
            form.setCaptchaChecked();
            form.verifyForm()
            //document.getElementById('submit').removeAttribute('disabled');
        }
    });
}

